import { DesignProp, GeneralProp } from "../PropCategories";

export const fontStyle = {
  prop: "style-attribute",
  name: "Font Style",
  nameI18n: "builder_ui.prop_type.styles.font_style",
  category: [DesignProp, GeneralProp],
  type: "select",
  defaultValue: "normal",
  options: [
    {
      label: "Normal",
      labelI18n: "builder_ui.prop_type.styles.font_style_types.normal",
      value: "normal",
    },
    {
      label: "Italic",
      labelI18n: "builder_ui.prop_type.styles.font_style_types.italic",
      value: "italic",
    },
    {
      label: "Oblique",
      labelI18n: "builder_ui.prop_type.styles.font_style_types.oblique",
      value: "oblique",
    },
    {
      label: "Inherit",
      labelI18n: "builder_ui.prop_type.styles.font_style_types.inherit",
      value: "inherit",
    },
    {
      label: "Initial",
      labelI18n: "builder_ui.prop_type.styles.font_style_types.initial",
      value: "initial",
    },
    {
      label: "Unset",
      labelI18n: "builder_ui.prop_type.styles.font_style_types.unset",
      value: "unset",
    },
  ],
} as const;
